// Long enough for a slow or dialog-gated save to read the blob before the
// object URL is released.
const REVOKE_DELAY_MS = 40_000

/**
 * Downloads a URL by clicking a transient anchor. An anchor click is a
 * navigation, not a fetch, so a cross-origin signed URL without CORS still
 * downloads. `filename` is advisory for cross-origin links: the server's
 * Content-Disposition wins.
 */
export const downloadFromUrl = (url: string, filename: string) => {
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.rel = 'noopener'
  document.body.appendChild(link)
  link.click()
  link.remove()
}

export const saveBlob = (blob: Blob, filename: string) => {
  const url = URL.createObjectURL(blob)
  downloadFromUrl(url, filename)
  setTimeout(() => URL.revokeObjectURL(url), REVOKE_DELAY_MS)
}
